import axios from '../axios'


// 添加账户明细
export const addAccountDetail = data => {
    return axios({
        url: '/api/account/detail/add',
        method: 'post',
        data
    })
}

// 查询当日账户支出明细
export const queryTodayAccountDetail = data => {
    return axios({
        url: '/api/account/queryTodayAccountDetail',
        method: 'post',
        data
    })
}

// 查询当日账户支出总金额
export const queryTodayAccountTotal = data => {
    return axios({
        url: '/api/account/queryTodayAccountTotal',
        method: 'post',
        data
    })
}

// 删除账户明细
export const deleteAccountDetailById = data => {
    return axios({
        url: '/api/account/deleteAccountDetailById',
        method: 'post',
        data
    })
}
